<script setup lang="ts">
const emit = defineEmits<{
  'update:model-value': [value: number]
}>()

const modelValue = ref(0)

const updateModelValue = (value: number) => {
  modelValue.value = value

  emit('update:model-value', value)
}
</script>

<template>
  <the-tabs :model-value="modelValue" @update:model-value="updateModelValue">
    <the-tabs-item :value="0">На карте</the-tabs-item>
    <the-tabs-item :value="1">Списком</the-tabs-item>
  </the-tabs>
</template>
